export enum PlayerState {
  start = 'start',
  resume = 'resume',
  pause = 'pause',
  init = 'init'
}
